<template>
  <div class="priority-item queue-complete">
    <div class="d-flex flex-column gap-50">
      <div class="d-flex align-items-center justify-content-between gap-10">
        <div class="d-flex align-items-center gap-10">
          <i class="fa fa-check queue-icon"></i>
          <h2>{{ 'Upload success' | trans }}</h2>
        </div>
      </div>
      <div>
        <p v-for="text in renderText" :key="text">{{ text }}</p>
      </div>
    </div>
    <p v-if="isFreeUser">
      {{ 'Get a subscription to bypass the queue, enjoy PRO features and process your files faster.' | trans }}
    </p>
    <button v-if="isFreeUser" class="btn queue-btn bg-warning w-50" @click="openPremiumModal">
      <i class="fa fa-chevron-right"></i><strong>{{ 'Get Premium' | trans }}</strong>
    </button>
  </div>
</template>

<script>
import store from './../../../mixins/store.mixin'
import currentJob from './../../../mixins/current_job.mixin'
import {
  registerPaymentModalHelper
} from "../../../../../../../../lib-sat/user/modal/register_payment_flow/register-payment-modal-helper";
import user from "../../../mixins/user.mixin";
import { translate } from '../../../../../../../helper/translate';

export default {
  name: "QueueComplete",
  props: {},
  components: {},
  mixins: [
    store,
    currentJob,
    user,
  ],
  data() {
    return {};
  },
  mounted: function () {
  },
  created: function () {
  },
  methods: {
    openPremiumModal() {
      registerPaymentModalHelper.openUpgrade().then(() => {
        this.modalToShow = null;
      });
    },
  },
  computed: {
    renderText() {
      let name = this.currentJob.uploadTo === 'gdrive' ? 'Google Drive' : 'Dropbox';
      let location = this.currentJob.uploadTo === 'gdrive' ? 'My Drive' : 'My Files';

      return [
        translate('Your files successfully uploaded to your %name%.', {'%name%': name}),
        translate('You can find them inside your "%location%" folder.', {'%location%': location})
      ]
    }
  }
};
</script>
<style lang="scss">

</style>
